var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.886c0-.143.062-.296.185-.458l6.45-8.131c.12-.153.247-.246.384-.28a.502.502 0 0 1 .376.044.46.46 0 0 1 .235.286c.047.134.035.291-.036.473L9.479 7.622h4.01c.151 0 .274.048.37.144.094.09.141.205.141.344 0 .148-.062.3-.184.458l-6.452 8.138a.719.719 0 0 1-.39.272.485.485 0 0 1-.61-.322c-.043-.134-.029-.294.042-.48l2.115-5.803H4.51a.511.511 0 0 1-.37-.136.48.48 0 0 1-.141-.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolt);
export default __webpack_public_path__ + "static/media/volt.93ff4ab02064c9de0951cb9bc41b0c9a.svg";
export { ForwardRef as ReactComponent };